import { Component, HostListener } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TableService } from './components/table/table.service';
import { AuthService } from './pages/login/auth.service';
import { MenuService } from './services/menu.service';
import { LoggingService } from 'src/app/services/logging.service';
import { AdminPermissionType } from './models/admin-permission.type';
import { IonicModule } from '@ionic/angular';
import { NgClass, NgIf, NgFor } from '@angular/common';
import { RouterLinkActive, RouterLink } from '@angular/router';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: true,
  imports: [IonicModule, NgClass, NgIf, NgFor, RouterLinkActive, RouterLink],
})
export class AppComponent {
  isProd: boolean = environment.production;

  public appPages = [
    { title: 'Dashboard', url: '/dashboard', icon: 'dashboard' },
    { title: 'Change Requests', url: '/change-requests-history', icon: 'history' },
    { title: 'Client Management', url: '/client-management', icon: 'users' },
    { title: 'Admin Users', url: '/admin-users', icon: 'admin' },
    { title: 'Fund Information', url: '/fund-information', icon: 'fund' },
    {
      title: 'BI Analytics',
      url: '/bi-analytics',
      icon: 'analytics',
      excludedDepartments: ['Sales'],
    },
    { title: 'Admin Panel', url: '/admin-data', icon: 'user-management' },
    {
      title: 'Template Manager',
      url: '/template-manager',
      icon: 'documents',
      requiredPermission: AdminPermissionType.MANAGE_TEMPLATES,
    },
    {
      title: 'Hyperlink Manager',
      url: '/hyperlink-manager',
      icon: 'share',
      requiredPermission: AdminPermissionType.MANAGE_HYPERLINKS,
    },
  ];

  menuOpen: boolean = false;
  adminDepartment: string = '';
  adminPermissions: AdminPermissionType[] = [];

  constructor(
    private tableService: TableService,
    private authService: AuthService,
    private menuService: MenuService,
    private loggingService: LoggingService,
  ) {}

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.authService.adminDepartment.subscribe((value) => {
      this.adminDepartment = value;
      LoggingService.log(value);
    });
    this.authService.adminPermissions.subscribe((permissions) => {
      this.adminPermissions = permissions || [];
      LoggingService.log(permissions);
    });
  }

  isPageVisible(page: any): boolean {
    if (page.excludedDepartments?.includes(this.adminDepartment)) {
      return false;
    }
    if (page.requiredPermission && !this.adminPermissions?.includes(page.requiredPermission)) {
      return false;
    }
    return true;
  }

  toggleMenu(state?: boolean) {
    LoggingService.log(state);
    if (state) {
      this.menuOpen = true;
    } else {
      this.menuOpen = !this.menuOpen;
      this.tableService.recalculate(true);
    }
    this.menuService.setMenuOpenStatus(this.menuOpen);
  }

  @HostListener('mousewheel', ['$event']) onMouseWheelChrome(event: any) {
    this.disableScroll(event);
  }

  @HostListener('DOMMouseScroll', ['$event']) onMouseWheelFirefox(event: any) {
    this.disableScroll(event);
  }

  @HostListener('onmousewheel', ['$event']) onMouseWheelIE(event: any) {
    this.disableScroll(event);
  }

  disableScroll(event: any) {
    if (event.srcElement.type === 'number') event.preventDefault();
  }
}
